export enum ManifestCarrier {
  DHL = "DHL",
  RRDONNELLEY = "RRDonnelley",
}
